// extracted by mini-css-extract-plugin
export default {"trailsText":"styles_trailsText__Uytks","container":"styles_container__JY+aK","item":"styles_item__WPefY","fg":"styles_fg__daySi","av":"styles_av__Rv00d"};